import {
  hhmmADoMMMYYYY,
  hhmmADoMMMYYYYNoIST,
  isNullUndefinedAndEmpty
} from '@fareye/utils'
import React from 'react'
import { Marker, Popup, L } from '@fareye/ui'
// import { OverspeedInstance } from '../../utils/types'
import { useTranslation } from '@fareye/common'

interface OverspeedMarkerProps {
  iconUrl: string
  iconSize: any
  overspeedInstance: any
  selected: boolean
  type?: string
}
export function OverspeedMarker({
  iconUrl,
  iconSize,
  overspeedInstance,
  selected,
  type = ''
}: OverspeedMarkerProps) {
  const { t } = useTranslation()

  const { landmark, speed, istTimestamp, latitude, longitude, gpsTimestamp } =
    overspeedInstance || {}
  let speedStr = `${isNullUndefinedAndEmpty(speed) ? '-' : speed + ' Km/hr'}`
  const [fakeState, setFakeState] = React.useState(0)

  return (
    <Marker
      position={L.latLng(latitude, longitude)}
      icon={new L.Icon({ iconUrl, iconSize, iconAnchor: [5, 10] })}
      eventHandlers={{
        click: () => setFakeState(fakeState + 1)
      }}
      // ref={el => openPopup(el)}
    >
      <Popup minWidth={149}>
        <h5>
          <strong>{t('Overspeed Details')} :</strong>
        </h5>
        <strong>{t('Landmark')}</strong>: {landmark}
        <br />
        <strong>{t('Speed')}</strong>:{speedStr}
        <br />
        <strong>{t('Time')}</strong>:
        {type === 'UTC'
          ? hhmmADoMMMYYYYNoIST(gpsTimestamp)
          : hhmmADoMMMYYYY(istTimestamp)}
      </Popup>
    </Marker>
  )
}
